export const MetaOriginIcon = ({ className, size = 10, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size * (10 / 14)} // Maintain aspect ratio (14x10)
        viewBox="0 0 14 10"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.8879 6.76339C1.8879 4.63527 2.95196 2.41463 4.20107 2.41463C4.89502 2.41463 5.45018 2.831 6.32918 4.08011C5.49644 5.37549 4.98754 6.16196 4.98754 6.16196C3.87722 7.91997 3.50712 8.29008 2.90569 8.29008C2.30427 8.33634 1.8879 7.78118 1.8879 6.76339ZM9.15125 5.97691L8.36477 4.68154C8.17972 4.35769 7.9484 4.03385 7.76335 3.75627C8.4573 2.69221 9.01245 2.13705 9.7064 2.13705C11.0943 2.13705 12.2046 4.2189 12.2046 6.80965C12.2046 7.78118 11.8808 8.33634 11.2331 8.33634C10.5854 8.33634 10.3541 7.91997 9.15125 5.97691ZM7.16192 2.831C6.14413 1.48937 5.26512 0.980469 4.24733 0.980469C2.11922 0.980469 0.5 3.80253 0.5 6.76339C0.5 8.61392 1.379 9.7705 2.85943 9.7705C3.92349 9.7705 4.6637 9.26161 6.0516 6.85591C6.0516 6.85591 6.60676 5.83812 7.02313 5.14417C7.16192 5.37549 7.30071 5.6068 7.4395 5.88438L8.08719 6.9947C9.3363 9.12282 10.0302 9.81677 11.2794 9.81677C12.7135 9.81677 13.5 8.61392 13.5 6.71712C13.4537 3.57122 11.7883 0.980469 9.79893 0.980469C8.73488 0.980469 7.90213 1.81321 7.16192 2.831Z"
            fill="#899CBD"
        />
    </svg>
)

export default MetaOriginIcon
